import React, { FunctionComponent, ReactElement } from 'react';

type SeparatorProps = {
    direction?: string;
}

const Separator: FunctionComponent<SeparatorProps> = (props: SeparatorProps): ReactElement => {
    const { direction } = props;
    if (direction === 'vertical') return <span className='vertical' data-testid='separator-vertical'/>;

    return (
        <div className='horizontal' data-testid='separator-horizontal'/>
    );
};

export default Separator;
